
import React, { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { Global } from '../../../Variables/Global';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { getDecodedToken } from '../../../utils/utils';
import axiosInstance from '../../../api/axiosConfig';

const Size = () =>{
     
    const [sizes, setSizes] = useState();

    const columns = [
        {
            name: '#',
            selector: row => row.productSizeId,
            width:"60px"
        },
        {
            name: 'Size Name',
            selector: row => row.productSizeName,
        },
        {
            name: 'Options',
            width: "170px",
            selector: row => {
                return (
                    <>
                    {permissions.editSize == true && (
                        <Link to={"/Settings/Size/" + row.productSizeId} className="btn btn-outline-warning mr-3">
                            <FiEdit />
                        </Link>
                    )}
                        {/* <button type="button" className="btn btn-outline-danger">
                            <FiTrash2 />
                        </button> */}
                    </>
                )
            },
        },
    ];

    const GetSizes = () => {
        var config = {
            method: 'get',
            url: "ProductSize/GetProductSize",
            headers: {},
        };

        axiosInstance(config)
            .then(function (response) {
                setSizes(response.data);
                console.log(response.data)
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const [permissions, setPermissions] = useState([])
    useEffect(() => {
        const decodedToken = getDecodedToken();
        const pJoin = JSON.stringify(JSON.parse(decodedToken.pJoin));
        var x = JSON.parse(pJoin);
        setPermissions(() => x);
        document.title = "Sizes";
        GetSizes();
    }, [])
    return (
        <>
        {permissions.viewSize == false ? (
                <>
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h1>You Have No Permission</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="page-title-box">
                                <h4>Sizes</h4>
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><a href="#">Mercator</a></li>
                                    <li className="breadcrumb-item active">Sizes</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col-12 col-md-6'>
                                        <h4 className="card-title">List Sizes</h4>
                                        </div>
                                        <div className='col-12 col-md-6 text-right'>
                                            {permissions.addSize == true && (
                                                <Link to="/Settings/Size/0" className="btn btn-primary">Add Sizes</Link>
                                            )}
                                        </div>
                                    </div>
                                    
                                    <DataTable
                                        columns={columns}
                                        data={sizes}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
            )}
            </>
    )
}
export default Size